import React from "react";
import { Avatar, Typography, Button } from "@material-ui/core";
import { makeStyles } from "@material-ui/core";

import Logo from "../../../../getKampus.png";

const useStyles = makeStyles((theme) => ({
    upperDiv: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      marginBottom: theme.spacing(3),
    },
    profilePic: {
      width: theme.spacing(25),
      height: theme.spacing(25),
      marginBottom: theme.spacing(2),
      backgroundColor: "white",
      // padding: theme.spacing(4),
      border: "2px solid #f0f0f0",
      boxShadow: "3px 5px 7px rgba(0,0,0,0.5)",
    },
    editButton: {
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(5),
    },
  }));

export default function UserProfile({currentUser,quote,author,setEdit}) {
    const classes = useStyles();

    return (
        <>
           <div className={classes.upperDiv}>
          <Avatar className={classes.profilePic} src={currentUser.photoURL || Logo}></Avatar>
          <Typography
            variant="h4"
            align="center"
            gutterBottom
          >
            {currentUser.displayName}
          </Typography>
          <Typography
            variant="h5"
            align="center"
            gutterBottom
          >
            {currentUser.email}
          </Typography>
          <Button
            variant="contained"
            color="secondary"
            className={classes.editButton}
            onClick={()=>setEdit(true)}
          >
            Edit Profile
          </Button>
        </div>
        <div className={classes.quotes}>
          <Typography
            variant="h5"
            align="center"
            gutterBottom
            style={{ fontWeight: 700, marginBottom: 20 }}
          >
            Motivational Quotes
          </Typography>
          <Typography variant="h6" align="center" gutterBottom>
            {quote}
          </Typography>
          <Typography
            variant="body1"
            align="center"
            gutterBottom
            style={{ opacity: 0.6 }}
          >
            {`~ ${author}`}
          </Typography>
        </div> 
        </>
    )
}
